// Denver's failure events. Call logEvent with a registered name (clientEventSchema.js) and
// ids/codes only: the event is validated, printed to devtools as name + fields, written to the
// desktop app's log file, and handed to every sink (shipping to Tokyo is one).
import { buildEvent, errorKind } from './clientEventSchema';

const sinks = new Set();
// Events logged before any sink exists (a boot failure before shipping starts) wait for the first.
const MAX_EARLY_EVENTS = 20;
const earlyEvents = [];

const deliver = (sink, event) => {
  try {
    sink(event);
  } catch (error) {
    // A sink must never break the code that reported a failure.
  }
};

export const addEventSink = sink => {
  sinks.add(sink);
  earlyEvents.splice(0).forEach(event => deliver(sink, event));
  return () => sinks.delete(sink);
};

export const logEvent = (name, fields = {}) => {
  const { event } = buildEvent(name, fields);
  if (!event) {
    console.error('client event not registered:', name);
    return;
  }

  console.warn(event.name, event.fields);
  if (window.api && window.api.logClientEvent) window.api.logClientEvent(event);
  if (!sinks.size) {
    if (earlyEvents.length < MAX_EARLY_EVENTS) earlyEvents.push(event);
    return;
  }
  for (const sink of sinks) deliver(sink, event);
};

// The bundle file an error came from, without its hash: ".../static/js/main.4f3a2b9c.js" -> "main".
const sourceFile = url => {
  const file = String(url || '').split(/[?#]/)[0].split('/').pop();
  const name = file.replace(/\.js$/, '').replace(/\.chunk$/, '').replace(/\.[0-9a-f]{6,}$/, '').toLowerCase();
  return /^[a-z0-9][a-z0-9_.:-]{0,63}$/.test(name) ? name : 'unknown';
};

export const installGlobalErrorHandlers = () => {
  const onError = event =>
    logEvent('app.error.unhandled', { error_kind: errorKind(event.error), source: sourceFile(event.filename) });
  const onRejection = event =>
    logEvent('app.error.unhandled', { error_kind: errorKind(event.reason), source: 'promise' });

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);
  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
};
